// extracted by mini-css-extract-plugin
export default {"buttons":"sort_buttons__2zT4-","sortIcon":"sort_sortIcon__4iBl9","up":"sort_up__n4Wcl","down":"sort_down__4MdKD","active":"sort_active__zlReq","icon":"sort_icon__WqOeo"};